import { IntakeFormWithProvider } from '@pages/IntakeFormPage';
import { SuspenseLoader } from '@router/components';
import { intakeFormLoader } from './intakeFormLoader';
import { INTAKE_FORM_ROUTE_PATHNAME } from '../routePathnames';
import { INTAKE_FORM_ROUTE_ID } from 'constants/routeIds';

export const intakeFormRoutes = [
  {
    id: INTAKE_FORM_ROUTE_ID,
    handle: {
      position: 1,
    },
    path: `${INTAKE_FORM_ROUTE_PATHNAME}/:id`,
    element: (
      <SuspenseLoader>
        <IntakeFormWithProvider />
      </SuspenseLoader>
    ),
    loader: intakeFormLoader,
  },
];
